import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Container } from '../../components/Container';
import { ProfessorEditModal } from '../../components/ProfessorEditModal';
import {
  getRedirectElement,
  projetosRoute,
  toLogout,
} from '../../library/Routes';
import { isAuthenticated } from '../../services/AuthService';
import { closeModal, openModal } from '../../store/modules/ModalActions';
import loginBackground from './../../assets/images/login-background.jpg';
import styles from './AutoCadastro.scss';

const rootClassName = styles.rootClassName;

class AutoCadastro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalKey: null,
    };

    this.toBackToLogin = this.toBackToLogin.bind(this);
  }

  toBackToLogin() {
    this.setState({
      ...this.state,
      modalKey: null,
    });
    toLogout(this.props.history);
  }

  componentDidMount() {
    if (!isAuthenticated()) {
      const currModal = this.props.openModal(ProfessorEditModal, {
        isAutoRegister: true,
        cancelCallback: this.toBackToLogin,
        savedCallback: this.toBackToLogin,
      });
      this.setState({
        ...this.state,
        modalKey: currModal.payload.key,
      });
    }
  }

  componentWillUnmount() {
    if (this.state.modalKey) {
      this.props.closeModal(this.state.modalKey);
    }
  }

  render() {
    return isAuthenticated() ? (
      getRedirectElement(projetosRoute.path)
    ) : (
      <Container
        className={rootClassName + '-container'}
        style={{
          backgroundImage: 'url(' + loginBackground + ')',
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      closeModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AutoCadastro));
